import { useCallback } from 'react';
import { filter } from 'lodash';
import { useConversions } from './useConversions';

export const useDeleteConversionEvent = (eventId, resetSteps) => {
    const { setConversions } = useConversions();

    const handleDeleteConversion = useCallback(() => {
        setConversions(prev => filter(prev, event => event.id !== eventId));
        resetSteps?.();
    }, [setConversions, eventId, resetSteps]);

    return handleDeleteConversion;
};
